


































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import CustomMap from '@/components/CustomMap.vue'
import {ICenter} from '@/store/modules/views/center/states'
import { UserProfile } from '@/store/modules/views/userProfile/states'


@Component({
  components: { CustomMap },
})
export default class CreateCenterDialog extends VueExtendedBaseComponent {
  @Prop({ default: '' }) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: () => void
  @Prop() private getList!: () => Promise<void>
  @Getter('userprofile/getProfile')
  private profile!: UserProfile


  private activePicker = null
  private valid = false
  private name = ''
  private loading = false
  private snackbar = false
  private address = ''
  private  map = {
    lat: 0,
    lon: 0,
  }
  private location: ICenter['address'] = {address: ''}

  private requireInput(value) { return value !== '' || 'จำเป็นต้องกรอก' }
  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get fieldValidate() {
    return this.formInstant.validate()
  }

  get invalidateInput() {
    return _.some(
        [
          this.validateInputFromType('text', this.address, true),
          this.validateInputFromType('number', this.map.lat.toString()),
          this.validateInputFromType('number', this.map.lon.toString()),
        ],
        (item) => item !== true,
    )
  }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get createCenterDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'เพิ่ม',
          action: this.createCenterAction,
          loading: this.loading,
          height: '30',
          color: 'primary',
        },
      },
    }
  }



  get validateInput() {
    return this.nameValidate(this.name)
  }

  private async createCenterAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      const url = process.env.VUE_APP_API_URL + '/v1/all/center'
      const data = {
        name: this.name,
        address: {address: this.address, ...this.location},
        map: this.map,
      }
      this.loading = true
      try {
        await HttpRequestServiceWithToken.post(url, data, async () => {
          this.updateSnackbar({txt: 'บันทึกศูนย์บริการสำเร็จ', type: 'success'})
          await this.callback()
          this.loading = false
          this.closeDialog()
        })
      } catch (e) {
        this.loading = false
      }
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
